if (!customElements.get('article-share')) {
  customElements.define(
    'article-share',
    class ArticleShare extends HTMLElement {
      constructor() {
        super();

        this.copyButton = this.querySelector('.article-share__copy');
        this.message = this.querySelector('.article-share__copy-message');

        if (this.copyButton) {
          this.copyButton.addEventListener('click', this.copyLink.bind(this));
        }
      }

      copyLink() {
        const url = this.copyButton.dataset.shareUrl;
        if (!url) return;

        navigator.clipboard.writeText(url).then(() => {
          this.copyButton.classList.add('is-copied');

          if (this.message) {
            this.message.textContent = window.accessibilityStrings ? window.accessibilityStrings.shareSuccess : '';
          }

          clearTimeout(this.copyTimeout);
          this.copyTimeout = setTimeout(() => {
            this.copyButton.classList.remove('is-copied');
            if (this.message) this.message.textContent = '';
          }, 2500);
        });
      }
    }
  );
}
